import styled, { css } from 'styled-components';

interface FormProps {
  disabled?: boolean;
}

const disabledCSS = css`
  opacity: 0.5;
  pointer-events: none;
`;

export const Form = styled.form<FormProps>`
  max-width: 388px;
  width: 100%;

  div {
    margin: 1rem 0;
  }

  a {
    color: #333333;
  }

  button {
    margin-top: 20px !important;
    margin-bottom: 10px !important;

    &.outline {
      background: transparent;
    }
  }

  label[for='info'] {
    font-size: 0.9rem;
  }

  @media (max-width: 580px) {
    width: 90%;
  }

  ${({ disabled }) => disabled && disabledCSS}
`;
